import React from 'react';
import GoogleMapReact, { MapOptions } from 'google-map-react';
import styledComponent from 'styled-components';
import useDocumentTitle from 'utils/customHooks/useDocumentTitle';
import { useParams } from 'react-router-dom';

export const OrderMapResults = () => {
  useDocumentTitle({ title: 'Map Results' });
  const { view:markerLocations } = useParams<{ view: string }>();
  const mapLocations =  JSON.parse(localStorage.getItem(markerLocations));
  const defaultCenter = { lat: 26.00, lng: -96  };
  const searchMarkers = mapLocations?.length ? mapLocations :[defaultCenter];

  const getMapBounds = (maps, locations) => {
    const bounds = new maps.LatLngBounds();
    locations.forEach(boundLocation => {
      bounds.extend(new maps.LatLng(boundLocation.latitude, boundLocation.longitude));
    });
    return bounds;
  };

  const bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
      maps.event.addDomListener(window, 'resize', () => {
        map.fitBounds(bounds);
      });
    });
  };
  
  const createMarkers = (map, maps, locations) => {
    const iw = new maps.InfoWindow();
    locations.forEach((location, i) => {
      maps.event.addListener(map, 'idle', () => {
        const marker = new maps.Marker({
          position: new maps.LatLng(location.latitude,location.longitude),
          map: map,
        });
        maps.event.addListener(marker, 'click', function () {
          iw.close();
          iw.setContent(location.infoHtml);
          iw.open(map, marker);
        });
      });
    });
  }
  const loadMap = (map, maps, locations) => {
    if (map) {
      const bounds = getMapBounds(maps,locations);
      map.fitBounds(bounds);
      bindResizeListener(map, maps, bounds);
      createMarkers(map, maps,locations);
    }
  };
  const loadMapOptions : MapOptions = {
    mapTypeControl : true,
    streetViewControl : true,
  };

  return (
    <Container>
      <GoogleMapReact 
        bootstrapURLKeys={{ key: globalThis?.app?.env?.REACT_APP_GOOGLE_API_KEY as string }}
        defaultCenter={defaultCenter}
        defaultZoom={13}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps}) => loadMap(map, maps, searchMarkers)}
        options={loadMapOptions}
      >
      </GoogleMapReact>
    </Container>
  );
};

const Container = styledComponent.div`
  height: 700px;
`;